// **********************************************************
// Main menu dropdown
// **********************************************************
attachEvent('.menu__arrow', 'click', (ev) => {
  if (windowWidth() < breakpointLg) {
    const arrowParent = ev.target.closest('.menu__item');
    const megaMenuDropdown = arrowParent.querySelectorAll('.mega-menu')[0];

    if (arrowParent.classList.contains('is-open-mega-menu')) {
      slideUp(megaMenuDropdown, 300);
      arrowParent.classList.remove('is-open-mega-menu');
    } else {
      arrowParent.classList.add('is-open-mega-menu');
      slideDown(megaMenuDropdown, 300);
    }
  }
});

// ------
// Toggle mega menu class
// ------
const menuLinks = document.querySelectorAll('.menu__item.has-mega-menu');

const toggleMegaMenu = (ele, toggle) => {
  document.body.classList.toggle('is-open-mega-menu', toggle);
  ele.classList.toggle('is-open-mega-menu', toggle);
  toggleBodyScrollLock(toggle);
};

menuLinks.forEach((el) => {
  if (windowWidth() > breakpointLg) {
    el.addEventListener('mouseenter', () => {
      toggleMegaMenu(el, true);
    });

    el.addEventListener('mouseleave', () => {
      toggleMegaMenu(el, false);
    });

    // ------
    // Close mega menu When Escape Key Press
    // ------

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        toggleMegaMenu(el, false);
      }
    });
  }
});
